import script from "./ShiftKiosk.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftKiosk.vue?vue&type=script&setup=true&lang=js"

import "./ShiftKiosk.vue?vue&type=style&index=0&id=266693d6&lang=css"

const __exports__ = script;

export default __exports__